import { PauseIcon, PlayIcon } from './Icons';

/**
 * The main button of a comparison room. It says what it will play ("Hear bar 9 in every
 * variation"), so the same round button never means different things on different pages.
 */
export function PlayButton({ playing, label, onPlay, onPause }: { playing: boolean; label: string; onPlay: () => void; onPause: () => void }) {
  return (
    <button className="btn primary" onClick={() => (playing ? onPause() : onPlay())} aria-live="polite">
      {playing ? <PauseIcon /> : <PlayIcon />}
      <span>{playing ? 'Pause' : label}</span>
    </button>
  );
}
